const previous = document.querySelector('.lf_tilskuds ul.f3-widget-paginator .previous a'),
    next = document.querySelector('.lf_tilskuds ul.f3-widget-paginator .next a');
if (previous) previous.innerHTML = '&lt;&lt;';
if (next) next.innerHTML = '&gt;&gt;';

$('.lf_tilskuds a').click(function (e) {
  e.preventDefault()
  let href = $(this).attr('href')
  let form = $('.lf-tilskuds-form')
  form.attr('action', href)
  form.submit()
})